import styled from 'styled-components';

import type { Rarity } from '__generated__/globalTypes';
import { AnimatedNumber } from 'atoms/animations/AnimatedNumber';
import { ButtonBase } from 'atoms/buttons/ButtonBase';
import { Horizontal } from 'atoms/layout/flex';
import { LabelM } from 'atoms/typography';
import { proxyUrl } from 'atoms/ui/ResponsiveImg';
import { getRewardImageUrl } from 'lib/rewards';

const IconWrapper = styled(Horizontal).attrs({ center: true })`
  width: var(--triple-unit);
  height: var(--triple-unit);
  border-radius: 50%;
  background: var(--c-nl-800);

  & > img {
    height: 16px;
    object-fit: contain;
  }
`;

const Root = styled(ButtonBase)`
  border-radius: var(--double-unit);
  padding-left: var(--unit);
  background: var(--c-nl-500);
  display: flex;
  &:hover {
    background: var(--c-nl-600);
  }
`;

type Props = {
  value: number;
  rarity: Rarity;
  cardSetSlug?: string;
};
export const EssenceBalance = ({ value, rarity, cardSetSlug }: Props) => {
  const imageUrl = getRewardImageUrl('shard', rarity, cardSetSlug);
  return (
    <Root>
      <Horizontal gap={0.5}>
        <LabelM bold>
          <AnimatedNumber value={value} disableAnimationOnFirstRender />
        </LabelM>
        <IconWrapper>
          <img
            src={proxyUrl(imageUrl, {
              cropWidth: 80,
            })}
            alt=""
            width={16}
            height={16}
          />
        </IconWrapper>
      </Horizontal>
    </Root>
  );
};
